import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable, of, throwError } from 'rxjs';
import { PetService } from '../pet/pet.service';
import { Pet, PetMissingReportStatus } from 'src/app/interfaces/pet';
import { catchError, tap } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';
import { UserService } from '../user/user.service';

@Injectable({
  providedIn: 'root'
})
export class PetResolverService {

  constructor(
    private service: PetService,
    private router: Router
  ) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
    let pet: Pet = null;
    if (route.parent.data.user) {
      pet = this.service.getOneFromUser(route.parent.data.user, parseInt(route.paramMap.get('id'), 10));
    }
    if (pet) {
      return pet;
    }
    this.router.navigate(['/my-pets']);
  }
}

@Injectable({
  providedIn: 'root'
})
export class MissingPetSubmissionResolverService {

  constructor(
    private service: PetService,
    private router: Router,
    private userService: UserService
  ) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
    let pet: Pet = null;
    if (route.parent.data.user) {
      pet = this.service.getOneFromUser(route.parent.data.user, parseInt(route.paramMap.get('id'), 10));
    }
    if (pet && !this.userService.isUserBasicOrBasicPlus(route.parent.data.user.productType)) {
      const activeMissingReport = pet.missingPetReports.find(r => r.reportStatus !== PetMissingReportStatus.Draft &&
                                                                  r.reportStatus !== PetMissingReportStatus.ClosedFound &&
                                                                  r.reportStatus !== PetMissingReportStatus.ClosedDeceased);

      if (activeMissingReport) {
        this.router.navigate(['/lost-and-found', 'missing-pet', activeMissingReport.id, 'edit']);
      } else {
        return pet;
      }
    } else {
      this.router.navigate(['/my-pets']);
    }
  }
}

@Injectable({
  providedIn: 'root'
})
export class MissingPetDraftReportResolverService {

  constructor(
    private service: PetService,
    private router: Router,
    private petService: PetService,
    private userService: UserService
  ) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
    const petId = parseInt(route.paramMap.get('id'), 10);
    let pet: Pet = null;
    if (route.parent.data.user) {
      pet = this.service.getOneFromUser(route.parent.data.user, petId);
    }
    if (!pet || this.userService.isUserBasicOrBasicPlus(route.parent.data.user.productType)) {
      this.router.navigate(['/my-pets']);
    }
    return this.petService.getMissingReportsForPet(petId)
    .pipe(
    );
  }
}

@Injectable({
  providedIn: 'root'
})
export class MissingPetResolverService {

  constructor(
    private service: PetService,
    private router: Router,
    ) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {

    return this.service.getPetMissingReport(parseInt(route.paramMap.get('reference'), 10), route.parent.data.user)
      .pipe(
        catchError(err => {
          if (err instanceof HttpErrorResponse && err.status === 404) {
            this.router.navigate(['/404']);
          }
          return throwError(err);
        })
      );
  }
}

@Injectable({
  providedIn: 'root'
})
export class MissingPetEditResolverService {

  constructor(
    private service: PetService,
    private router: Router,
    private userService: UserService
  ) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
    if (!route.parent.data.user) {
      this.router.navigate(['/login']);
    } else {
      const reportId = parseInt(route.paramMap.get('reference'), 10);
      const pet = this.service.getMissingFromUser(route.parent.data.user, reportId);
      if (pet && !this.userService.isUserBasicOrBasicPlus(route.parent.data.user.productType)) {
        const report = pet.missingPetReports.find(r => r.id === reportId);
        if (report.reportStatus === PetMissingReportStatus.ClosedFound ||
            report.reportStatus === PetMissingReportStatus.ClosedDeceased) {
          this.router.navigate(['/lost-and-found', 'missing-pet', reportId]);
        } else {
          return pet;
        }
      } else {
        this.router.navigate(['/my-pets']);
      }
    }
  }
}
